import MoreVert from "@mui/icons-material/MoreVert";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

export default function ManageButton({ onClickDeleteMember }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            <IconButton onClick={handleClick}>
                <MoreVert />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} sx={{ minWidth: 500 }}>
                <MenuItem sx={{ color: "red" }} onClick={onClickDeleteMember}>
                    Delete
                </MenuItem>
            </Menu>
        </Box>
    );
}
